.drawer {
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-top: 1px solid var(--tuna-palette-divider);
  background: var(--tuna-palette-background-default);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.title {
  font-size: var(--tuna-typography-fontSize-xl);
  font-weight: 600;
  margin: 0;
}

.modalFooter {
  font-size: var(--tuna-typography-fontSize-md);
  color: var(--tuna-palette-text-secondary);
  margin: 0 0 12px 0;
  font-style: italic;
}

.prefixStrip {
  font-size: var(--tuna-typography-fontSize-md);
  margin-bottom: 12px;
  color: var(--tuna-palette-text-secondary);
}

.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.closeButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  font-size: var(--tuna-typography-fontSize-2xl);
  line-height: 1;
}

@media (max-width: 599.95px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
